import { Button, Stack, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { ReactNode } from 'react'
import { COLOR_PALLETE } from '~/COLOR_PALLETE'

type Props = {
  headerText: string
  bodyText: string
  linkText?: string
  redirectTo?: string
  onClick?: () => void
  time?: string
  id?: string
  titleColor?: string
  textColor?: string
  bgColor?: string
  btnTextColor?: string
  btnColor?: string
  icon?: ReactNode
  className?: string
}

//TODO somehow som skoncil s komponentom ala Mato Hamala. Refactornut na viacej mensich.

export const InfoCard = ({
  headerText,
  bodyText,
  linkText,
  redirectTo = '',
  onClick,
  id,
  titleColor = COLOR_PALLETE.zBlack200,
  textColor = COLOR_PALLETE.zBlack200,
  bgColor = COLOR_PALLETE.zGrey200,
  btnTextColor = COLOR_PALLETE.zBlack200,
  btnColor = '#DED4FF',
  icon,
  className = '',
}: Props) => {
  return (
    <Stack
      className={`p-4 rounded-4d ${className}`}
      style={{ background: bgColor }}>
      <Stack className="flex-row justify-between items-center mt-0.5 mb-2.5">
        <Stack className="flex-row items-center gap-2">
          {icon}
          <Typography
            className="text-base font-semibold self-center flex-shrink-0"
            style={{ color: titleColor }}>
            {headerText}
          </Typography>
        </Stack>
        {id && (
          <Typography
            className="text-xs font-bold truncate pr-2"
            style={{ color: textColor }}>
            {`ID: ${id}`}
          </Typography>
        )}
      </Stack>
      <Typography className="text-3d font-medium " style={{ color: textColor }}>
        {bodyText}
      </Typography>
      {redirectTo && (
        <Link to={redirectTo} color="inherit" className=" mt-4">
          <Typography
            className="text-sm font-semibold underline underline-offset-2"
            style={{ color: textColor }}>
            {linkText}
          </Typography>
        </Link>
      )}
      {onClick && (
        <Button
          variant="contained"
          className={`w-fit px-6 mt-4`}
          style={{ background: btnColor }}
          onClick={onClick}>
          <Typography
            className="text-3d font-medium"
            style={{ color: btnTextColor }}>
            {linkText}
          </Typography>
        </Button>
      )}
    </Stack>
  )
}
